import React from "react";
import classnames from "classnames";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";

const SpinnerWrapper = styled.div`
  &.overlayed {
    position: absolute;
    display: flex;
    left: 0;
    right: 0;
    justify-content: center;
    z-index: 2;

    .spinner-border-sm.spinner-border {
      color: #fff !important;
    }
  }

  &.backdrop {
    align-items: center;
    background-color: #7e7e7e3d;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    vertical-align: middle;
  }
`;

const CustomSpinner = ({
  overlay = false,
  backdrop = false,
  alignment = "",
  ...props
}) => {
  return (
    <SpinnerWrapper
      className={classnames("custom-spinner", {
        "text-center": alignment === "center",
        overlayed: overlay,
        backdrop,
      })}
    >
      <Spinner {...props} />
    </SpinnerWrapper>
  );
};

CustomSpinner.propTypes = {
  overlay: PropTypes.bool,
  backdrop: PropTypes.bool,
  alignment: PropTypes.string,
};

export default CustomSpinner;
